exports = module.exports = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-uploader-icon{font-size:28px;width:120px;height:120px;line-height:120px;text-align:center}.avatar{width:120px;height:120px;display:block;border-radius:50%}.user-info{padding-left:0;list-style:none}.user-info li{border-bottom:1px solid #f0f3f4;padding:11px 0;font-size:13px}.user-info .user-right{float:right}.user-info .user-right a{color:#317ef3}.pagebox{text-align:right;margin-top:15px}", ""]);

// exports
